const t = {
  informative: "info",
  attention: "exclamation",
  critical: "exclamation"
};
export {
  t as ICONS_BY_TYPE
};
